import { render } from "./ComparisonBar.vue?vue&type=template&id=354e5232"
import script from "./ComparisonBar.vue?vue&type=script&lang=js"
export * from "./ComparisonBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__